export const CONTROL_GROUP = 'control';
export const EXPERIMENT_GROUP = 'experiment';
export const NOT_IN_EXPERIMENT_GROUP = 'not_in_experiment';
